
export const virtualPath = '';
export const autoCompleteDelay = 300;
export const commonToken = 'LXGIWYLHESOYAMAEZAKMI';

